import { DefaultTheme, createGlobalStyle } from 'styled-components'

const StyledTheme: DefaultTheme = {
  fontFamily: "'SF Pro Display', sans-serif",

  borderRadius: '5px',

  colors: {
    primary: '#5A58F2',
    secondary: 'white',
  },

  responsive: {
    tablet: {
      valueString: '1024px',
      valueNumber: 1024,
    },
    mobile: {
      valueString: '480px',
      valueNumber: 480,
    },
  },
}

const GlobalStyle = createGlobalStyle`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;

    // hack for PDF preview with apryse
    iframe[title="js"] {
      position: absolute !important;
    }
  }

  * {
    font-family: ${({ theme }) => theme.fontFamily};

    &::-webkit-scrollbar {
      width: 8px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 4px;
      margin: 8px 0;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #E5E7EB;
      border-radius: 4px;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #D1D5DB;
      }
    }

    /* Firefox Scrollbar Styles */
    scrollbar-width: thin;
    scrollbar-color: #E5E7EB transparent;

    &:hover {
      scrollbar-color: #D1D5DB transparent;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  #crisp-chatbox-chat {
    @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
      top: var(--safe-area-inset-top, 0px) !important;
    }
    .c-chat {
      @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
        height: 90%;    
      }
    }
  }

  #crisp-chatbox-button, .cc-18ov6 {
    @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
      margin-bottom: calc(55px + var(--safe-area-inset-bottom, 0px)) !important;
    }
  }


  .crisp-client {
    --crisp-customization-mobile-button-vertical: calc(55px + var(--safe-area-inset-bottom, 0px)) !important;
    /* z-index: var(--crisp-customization-container-index)!important; */

  ::-webkit-scrollbar-button { 
    display:none;
  }
}
`

export { StyledTheme, GlobalStyle }
